module.exports = __webpack_public_path__ + "static/media/ScottParrProfile.1dc63b6b.png";